import * as angular from 'angular';

import { ComponentDefinition, Group, DefaultGridsterOptions, IGridsterOptions } from '../../../models';

class GeneralStateController implements angular.IComponentController {
    gridsterOptions: IGridsterOptions;
    groupGuid: string;
    isLoading: boolean;
    loadingMessage: string;
    selectedGroup: Group;

    static $inject = [];

    $onInit() {
        this.gridsterOptions = DefaultGridsterOptions;
        if (this.selectedGroup.script) {
            this.selectedGroup.script = this.selectedGroup.script.trim();
        }
    }
}

export const wtGeneralState: ComponentDefinition = {
    componentId: 'wtGeneralState',
    controller: GeneralStateController,
    template: require('./generalState.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedGroup: '<',
        gridsterOptions: '<'
    }
};
